<div class="px-3">
    <div class="rem-text-default mb-6">
        <div class="flex align-items-end">
            <div class="rem-bg-light px-3 py-3 mr-2">
                <i class="pi pi-cog font-medium text-xl"></i>
            </div>
            <div>
                <div class="text-2xl font-medium">Remitter SMS Config</div>
                <div class="text-right mt-2">Manage Remitter SMS Configurations</div>
            </div>
        </div>
    </div>
    <div class="flex justify-content-between align-items-center mt-4 pr-4">
        <div class="flex align-items-center gap-2">
            <p-floatLabel>
                <p-autoComplete [class]="cssClass"
                                [styleClass]="styleClass"
                                [(ngModel)]="selectedClient"
                                [suggestions]="filteredClients"
                                (completeMethod)="filterClients($event)"
                                (onKeyUp)="onKeyUp($event)"
                                (onSelect)="onSelectClient($event)"
                                [dropdown]="true"
                                optionLabel="Name"
                                placeholder="Select Client"
                                id="clients">
                    <ng-template let-client pTemplate="item">
                        <div class="flex align-items-center justify-content-between flex-1">
                            <div>{{ client.Id }}</div>
                            <div>{{ client.Name }}</div>
                        </div>
                    </ng-template>
                </p-autoComplete>
                <label for="clients">Clients</label>
            </p-floatLabel>
            <remitter-button (click)="searchConfigurations()" label="Search" icon="search" severity="secondary"></remitter-button>
        </div>
        <remitter-button (click)="editLenderConfiguration(0)" label="New SMS Configuration" icon="plus" severity="info"></remitter-button>
    </div>
    <br />
    <div *ngIf="searchResults?.length" class="mt-4 pt-2 px-3">
        <div class="px-2">
            <div class="font-bold">
                SMS Configurations
            </div>
        </div>
        <p-table *ngIf="searchResults.length > 0" [value]="searchResults" [paginator]="true" [rows]="20" [tableStyle]="{ 'min-width': '50rem' }" [rowsPerPageOptions]="[20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Client</th>
                    <th>Lender</th>
                    <th>LenderId</th>
                    <th>Is Disabled</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-searchResult>
                <tr>
                    <td (click)="editLenderConfiguration(searchResult.TwilioIntegrationId)">
                        <i pTooltip="View Details" tooltipPosition="right" class="pi pi-map icon text-xs cursor-pointer"></i>
                    </td>
                    <td (click)="editLenderConfiguration(searchResult.TwilioIntegrationId)">{{ searchResult.ClientName }}</td>
                    <td (click)="editLenderConfiguration(searchResult.TwilioIntegrationId)">{{ searchResult.LenderName }}</td>
                    <td (click)="editLenderConfiguration(searchResult.TwilioIntegrationId)">{{ searchResult.LenderId }}</td>
                    <td (click)="editLenderConfiguration(searchResult.TwilioIntegrationId)">{{ searchResult.IsDisabled ? 'Yes' : 'No' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-sidebar [(visible)]="isItemEditorVisible" styleClass="w-4" position="right">
        <div class="grid mt-2">
            <div class="col-12 md:col-8">
                <div class="mt-5">
                    <p-floatLabel>
                        <p-autoComplete [(ngModel)]="editorSelectedClient"
                                        [suggestions]="editorFilteredClients"
                                        (completeMethod)="filterEditorClients($event)"
                                        (onSelect)="onEditorSelectClient($event)"
                                        [dropdown]="true"
                                        optionLabel="Name"
                                        placeholder="Select Client"
                                        id="editorClient">
                            <ng-template let-client pTemplate="item">
                                <div class="flex align-items-center justify-content-between flex-1">
                                    <div>{{ client.Id }}</div>
                                    <div>{{ client.Name }}</div>
                                </div>
                            </ng-template>
                        </p-autoComplete>
                        <label for="editorClient">Client</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.LenderName" class="w-full" pInputText id="LenderName" placeholder="Lender Name" />
                        <label for="LenderName">Lender Name</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.UniqueId" class="w-full" pInputText id="UniqueId" placeholder="Unique Id" />
                        <label for="UniqueId">Lender Unique Id</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.AccountSid" class="w-full" pInputText id="AccountSid" placeholder="Twilio Account SID" />
                        <label for="AccountSid">Twilio Account SID</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.MessagingServiceSid" class="w-full" pInputText id="MessagingServiceSid" placeholder="Messaging Service SID" />
                        <label for="MessagingServiceSid">Twilio Messaging Service SID</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.AuthToken" class="w-full" pInputText id="AuthToken" placeholder="Auth Token" />
                        <label for="AuthToken">Twilio Auth Token</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.LenderOutboundWebhookUrl" class="w-full" pInputText id="OutboundWebhookUrl" placeholder="Outbound Webhook URL" />
                        <label for="OutboundWebhookUrl">Lender Outbound Webhook URL</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <p-floatLabel>
                        <input [(ngModel)]="currentLenderConfiguration!.LenderInboundWebhookUrl" class="w-full" pInputText id="InboundWebhookUrl" placeholder="Inbound Webhook URL" />
                        <label for="InboundWebhookUrl">Lender Inbound Webhook URL</label>
                    </p-floatLabel>
                </div>
                <div class="mt-5">
                    <remitter-button (click)="saveLenderConfiguration()" label='Save' icon='send'></remitter-button>
                </div>
            </div>
        </div>
    </p-sidebar>

